import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "app/storybookComponents/Button";
import { downloadCSV } from "utils/helperFunctions";
interface Props {
  headers: {
    key?: string;
    label: string;
  }[];
  getRows: () => {
    [headerKey: string]: string | number;
  }[];
  fileName?: string;
  buttonText?: React.ReactNode;
  disabled?: boolean;
  variant?: "secondary-blue" | "link";
  className?: string;
}

const ExportCSVButton = ({
  headers,
  getRows,
  fileName,
  buttonText,
  disabled,
  variant,
  className,
}: Readonly<Props>) => {
  const onClick = () => {
    if (disabled) return;
    const rows = getRows();
    const data = [headers.map((header) => header.label)];
    rows.forEach((row) => {
      data.push(
        headers.map((header) => `${row[header.key ?? header.label] ?? ""}`)
      );
    });
    downloadCSV(fileName ?? "export", data);
  };

  return (
    <Button
      onClick={onClick}
      variant={variant ?? "secondary-blue"}
      className={className ?? "border-0"}
      disabled={disabled}
    >
      {buttonText ?? (
        <>
          <FontAwesomeIcon icon="upload" className="me-2" />
          Export CSV
        </>
      )}
    </Button>
  );
};

export default ExportCSVButton;
